'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.columns');
var _wavfichacertaFichacertaSharedStyles2 = require('@bit/wavfichacerta.fichacerta.shared-styles.rows');
var _inputsStyles = require('../inputsStyles/inputsStyles');
var _TextInput = require('./TextInput');
var _TextInput2 = _interopRequireDefault(_TextInput);
var _SelectInput = require('./SelectInput');
var _SelectInput2 = _interopRequireDefault(_SelectInput);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ComposedInputs = function (_PureComponent) {
  _inherits(ComposedInputs, _PureComponent);
  function ComposedInputs() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ComposedInputs);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ComposedInputs.__proto__ || Object.getPrototypeOf(ComposedInputs)).call.apply(_ref, [this].concat(args))), _this), _this.renderFields = function () {
      var _this$props = _this.props,
        innerInputs = _this$props.innerInputs,
        after = _this$props.after,
        names = _this$props.names;
      var mappedFields = names.map(function (fieldName) {
        var customstyle = innerInputs[fieldName].label === 'WITHOUT_LABEL' ? 'margin-top: 1.9rem !important;' : '';
        if (innerInputs[fieldName].type === 'select') {
          return _react2.default.createElement(_SelectInput2.default, Object.assign({}, _this.props[fieldName], innerInputs[fieldName], {
            key: fieldName,
            options: innerInputs[fieldName].options,
            customstyle: customstyle
          }));
        }
        return _react2.default.createElement(_react.Fragment, {
          key: fieldName
        }, _react2.default.createElement(_TextInput2.default, Object.assign({}, _this.props[fieldName], innerInputs[fieldName], {
          key: fieldName,
          customstyle: customstyle
        })), after);
      });
      return mappedFields;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ComposedInputs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        size = _props.size,
        label = _props.label;
      return _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.BaseColumn, {
        'data-testid': 'ComposedInputs',
        className: size
      }, _react2.default.createElement(_inputsStyles.StyledLabel, {
        customstyle: {
          position: 'absolute',
          bottom: '30px',
          left: '12px'
        }
      }, label), _react2.default.createElement(_wavfichacertaFichacertaSharedStyles2.StyledRow, {
        customstyle: {
          margin: 0,
          padding: 0,
          width: '100%'
        }
      }, this.renderFields()));
    }
  }]);
  return ComposedInputs;
}(_react.PureComponent);
ComposedInputs.defaultProps = {
  isRequired: false
};
exports.default = ComposedInputs;